import axios, { AxiosError, AxiosResponse } from 'axios';

import { getAPIUrl } from './config';
import ISubmission from './ServerEntities/Submission';

export const getAnswers = (code: string, webToken: string, successCallback: (submission: ISubmission) => void, failureCallback: (error: AxiosError) => void) => {
    axios.get(
        `${getAPIUrl()}public/${code}/answers`,
        { headers: { Authorization: `Bearer ${webToken}`, "Content-type": "application/json" } }
    ).then((response: AxiosResponse<ISubmission>) => {
        successCallback(response.data);
    })
    .catch((error: AxiosError) => {
        failureCallback(error);
    });
};

export const saveAnswer = (questionId: number, answer: string, webToken: string, successCallback: () => void, failureCallback: (error: AxiosError, questionId: number) => void) => {
    axios.post(
        `${getAPIUrl()}public/save`,
        { questionId, answer },
        { headers: { Authorization: `Bearer ${webToken}`, "Content-type": "application/json" } }
    ).then((response: AxiosResponse<undefined>) => {
        successCallback();
    })
        .catch((error: AxiosError) => {
            failureCallback(error, questionId);
        });
};

export const deleteAnswer = (questionId: number, webToken: string, successCallback: (value: any) => void, failureCallback: (error: AxiosError, questionId: number) => void) => {
    axios.post(
        `${getAPIUrl()}public/delete`,
        { questionId },
        { headers: { Authorization: `Bearer ${webToken}`, "Content-type": "application/json" } }
    )
        .then(() => {
            successCallback("ok");
        })
        .catch((error: AxiosError) => {
            failureCallback(error, questionId);
        });
};

export const saveHelp = (questionId: number, answer: string, help: boolean, webToken: string, successCallback: () => void, failureCallback: (error: AxiosError, questionId: number) => void) => {
    axios.post(
        `${getAPIUrl()}public/help`,
        { questionId, answer, help },
        { headers: { Authorization: `Bearer ${webToken}`, "Content-type": "application/json" } }
    ).then((response: AxiosResponse<undefined>) => {
        successCallback();
    })
        .catch((error: AxiosError) => {
            failureCallback(error, questionId);
        });
};


export const submitForm = (webToken: string, successCallback: () => void, failureCallback: (error: AxiosError) => void, check?: string) => {
    let url = `${getAPIUrl()}public/finish`
    if (check) {
        url += "/check";
    }
    else {
        url += "/save";
    }
    axios.post(
        url,
        {},
        { headers: { Authorization: `Bearer ${webToken}`, "Content-type": "application/json" } }
    ).then((response: AxiosResponse<undefined>) => {
        successCallback();
    })
        .catch((error: AxiosError) => {
            failureCallback(error);
        });
};




// WEBPACK FOOTER //
// ./src/service.ts